const NoPage = () => {
    return <h2>We tried, but page not found (404)</h2>;
  };
  
  export default NoPage;